import React, { useState } from "react";
import "../assets/styles/Form.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
    contactPreference: "",
    honeypot: "", // Campo oculto
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Verificar si el honeypot está vacío
    if (formData.honeypot) {
      console.log("Spam detectado");
      return; // No procesar el formulario si el honeypot está lleno
    }

    try {
      const response = await fetch("/sendMail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          contactPreference: formData.contactPreference,
          honeypot: formData.honeypot, // Enviar el campo honeypot
        }),
      });

      if (response.ok) {
        console.log("Formulario enviado exitosamente");
        alert("Formulario enviado con éxito. Pronto nos pondremos en contacto.");
        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
          contactPreference: "",
          honeypot: "",
        }); // Limpiar el formulario
      } else {
        console.error("Error al enviar el formulario");
        alert("Hubo un error al enviar el formulario. Intenta nuevamente.");
      }
    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
      alert("Hubo un error al conectar con el servidor.");
    }
  };

  return (
    <section
      className="contact-section m-4"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-easing="ease-out-cubic"
      data-aos-duration="2000"
    >
      <form className="contact-form" onSubmit={handleSubmit}>
        <h2 className="form-title">
          <i className="fas fa-comments me-2"></i> <br />
          Contáctanos
        </h2>

        {/* Campo oculto Honeypot */}
        <div className="honeypot">
          <label htmlFor="honeypot" className="d-none">
            No llenar este campo
          </label>
          <input
            type="text"
            id="honeypot"
            name="honeypot"
            value={formData.honeypot}
            onChange={handleChange}
            tabIndex="-1"
            autoComplete="off"
            className="d-none"
          />
        </div>

        {/* Nombre completo */}
        <div className="form-group">
          <label htmlFor="name">
            <i className="fas fa-user"></i> Nombre Completo
          </label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Escribe tu nombre completo"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        {/* Teléfono */}
        <div className="form-group">
          <label htmlFor="phone">
            <i className="fas fa-phone-alt"></i> Teléfono
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Ingresa tu número de teléfono"
            required
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* Correo electrónico */}
        <div className="form-group">
          <label htmlFor="email">
            <i className="fas fa-envelope"></i> Correo Electrónico
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Ingresa tu correo electrónico"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* Asunto */}
        <div className="form-group">
          <label htmlFor="subject">
            <i className="fas fa-tag"></i> Asunto
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            placeholder="¿Cuál es el motivo de tu mensaje?"
            required
            value={formData.subject}
            onChange={handleChange}
          />
        </div>

        {/* Mensaje */}
        <div className="form-group">
          <label htmlFor="message">
            <i className="fas fa-comment-alt"></i> Mensaje
          </label>
          <textarea
            id="message"
            name="message"
            placeholder="Escribe tu mensaje"
            rows="5"
            required
            value={formData.message}
            onChange={handleChange}
            style={{ resize: "none" }}
          ></textarea>
        </div>

        {/* Preferencia de contacto */}
        <div className="form-group">
          <label htmlFor="contactPreference">
            <i className="fas fa-handshake"></i> Preferencia de contacto
          </label>
          <select
            id="contactPreference"
            name="contactPreference"
            required
            value={formData.contactPreference}
            onChange={handleChange}
          >
            <option value="">Selecciona una opción</option>
            <option value="telefono">Teléfono</option>
            <option value="correo">Correo Electrónico</option>
            <option value="whatsapp">WhatsApp</option>
          </select>
        </div>

        <button type="submit" className="btn btn-primary">
          Enviar Mensaje
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
  
